import React from 'react';
import { Link } from 'gatsby';

function Flyer() {
  const [show, setShow] = React.useState(true);
  const toggle = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setShow(false);
  };
  return (
    <div
      className={`fixed bottom-0 left-0 w-full h-16 bg-blue-700 px-4 lg:px-8 py-2 text-white flex flex-row flex-wrap z-20 ${
        show ? '' : 'hidden'
      }`}
    >
      <div className="flex-1 text-center my-auto mx-auto">
        <Link to="/congreso">
          <h2
            className="text-sm md:text-xl leading-loose border-white underline"
            style={{ letterSpacing: '1px' }}
          >
            Participa en el VI Congreso de la SVRID
          </h2>
        </Link>
      </div>
      <div className="h-full w-8 flex">
        <button
          type="button"
          className="m-auto bg-transparent text-center w-8"
          onClick={toggle}
        >
          <svg fill="currentColor" className="w-6 h-6" viewBox="0 0 20 20">
            <path
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clipRule="evenodd"
              fillRule="evenodd"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}

export default Flyer;
